import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

export default function DrugAllergyInteractions(props: any) {
  const { eachData } = props;
  return (
    <>
      <Typography
        component="div"
        variant="body2"
        fontWeight={600}
        marginBottom={1}
      >
        Allergy Interactions:
        {eachData?.drugAllergyMessages?.length >= 1 ? (
          <Box className="info">
            {eachData?.drugAllergyMessages?.map((each: any) => (
              <Typography key={each?.id} component="div" variant="body2">
                <strong>
                  {each?.id} {each?.drugName}
                </strong>
                : {each?.warnings}
                <Typography variant="body2" color={"red"} display={"inline"}>
                  Severity Level: {each?.severityLevel ?? "Not Available"}
                </Typography>
                {each?.references && (
                  <Typography component="div" variant="body2">
                    <Typography
                      variant="body2"
                      color={"blue"}
                      display={"inline"}
                    >
                      REFERENCES:
                    </Typography>{" "}
                    <Typography
                      variant="body2"
                      color={"green"}
                      display={"inline"}
                    >
                      {each?.references ?? "Not Available"}
                    </Typography>
                  </Typography>
                )}
              </Typography>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color={"blue"} display={"inline"}>
            No Known Drug Allergy Interactions{" "}
          </Typography>
        )}
      </Typography>
      <Typography
        component="div"
        variant="body2"
        fontWeight={600}
        marginBottom={1}
      >
        Drug Interactions:
        {eachData?.drugToDrugInteractionMessages?.length >= 1 ? (
          <Box className="info" height={"150px"} overflow={"auto"}>
            {eachData?.drugToDrugInteractionMessages?.map((each: any) => (
              <Typography key={each.id} component="div" variant="body2">
                <strong>
                  {each?.id} {each?.drugName}
                </strong>
                : {each?.warnings}
                <Typography variant="body2" color={"red"} display={"inline"}>
                  Severity Level: {each?.severityLevel ?? "Not Available"}
                </Typography>
                {each?.references && (
                  <Typography component="div" variant="body2">
                    <Typography
                      variant="body2"
                      color={"blue"}
                      display={"inline"}
                    >
                      REFERENCES:
                    </Typography>{" "}
                    <Typography
                      variant="body2"
                      color={"green"}
                      display={"inline"}
                    >
                      {each?.references ?? "Not Available"}
                    </Typography>
                  </Typography>
                )}
              </Typography>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color={"blue"} display={"inline"}>
            No Known Drug To Drug Interactions{" "}
          </Typography>
        )}
      </Typography>
    </>
  );
}
